import * as types from '../constants/ActionTypes';

export const userFBToken = token => ({ type: types.USER_FB_TOKEN, token });

export const setFBAccessToken = token => (dispatch) => {
  dispatch(userFBToken({ token }));
};



// WEBPACK FOOTER //
// ./src/actions/FBUserActions.js